<template>
    <div class="w-full pb-4 lg:w-max lg:pb-0">
        <div
            @click="$emit('toggle')"
            class="mb-5 flex cursor-pointer items-center justify-between border-b border-white pb-5 lg:pointer-events-none lg:border-none lg:pb-0">
            <span class="styled-as-h3 text-sm lg:text-xl">
                {{ category?.translated?.name }}
            </span>
            <IconChevronDown :class="{ '-rotate-180': open }" class="mr-5 size-4 lg:hidden" />
        </div>
        <nav
            v-if="category?.children"
            class="overflow-hidden pt-1.5 pl-5 duration-300 lg:pl-0"
            :class="{
                '!max-h-screen': open,
                '!max-h-0 lg:!max-h-full': !open,
            }">
            <ul>
                <li>
                    <template v-for="childCategory in visibleChildren">
                        <NuxtLink
                            v-if="childCategory.linkType === 'category' && getUrlById(childCategory.id)"
                            class="mb-7 block w-max text-sm leading-none duration-200 hover:text-green-600"
                            :to="getUrlById(childCategory.id)">
                            {{ childCategory?.translated?.name }}
                        </NuxtLink>
                        <NuxtLink
                            v-else-if="childCategory.linkType === 'category' && getUrlById(childCategory.internalLink)"
                            class="mb-7 block w-max text-sm leading-none duration-200 hover:text-green-600"
                            :to="getUrlById(childCategory.internalLink)">
                            {{ childCategory?.translated?.name }}
                        </NuxtLink>
                        <NuxtLink
                            v-else-if="childCategory.linkType === 'external'"
                            class="mb-7 block w-max text-sm leading-none duration-200 hover:text-green-600"
                            :to="childCategory.externalLink">
                            {{ childCategory?.translated?.name }}
                        </NuxtLink>
                        <NuxtLink
                            v-else-if="getUrlById(childCategory.id)"
                            class="mb-7 block w-max text-sm leading-none duration-200 hover:text-green-600"
                            :to="getUrlById(childCategory.id)">
                            {{ childCategory?.translated?.name }}
                        </NuxtLink>
                    </template>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script setup lang="ts">
    import { isSitemapFooterLink } from '~/utils/footerLinks';
    const props = defineProps<{
        category: any;
        open: boolean;
    }>();

    defineEmits<{
        toggle: [];
    }>();

    const { getUrlById } = useCategorySeoUrl();
    const config = useRuntimeConfig();
    const visibleChildren = computed(() =>
        (props.category?.children ?? []).filter((child: any) => {
            const url =
                child.linkType === 'external'
                    ? child.externalLink
                    : getUrlById(child.id) || getUrlById(child.internalLink);
            return !isSitemapFooterLink(url, String(config.public.prodUrl));
        }),
    );
</script>
